import HorizontalNavbar from "../components/MainNavs/HorizontalNavbar";
import { AuthContextProvider } from "../context/authContext";
import { msalInstance } from "../utils/msal";
import { MsalProvider } from "@azure/msal-react";
import { Outlet } from "react-router-dom";
import { Schedule4DProvider } from "../pages/client/AllEquipments/CommonFeatures/MCS3/Schedule4D/Schedule4DContext";
import ModuleRouteGuard from "../components/RoutesHandler/ModuleRouteGuard";

export const GlobalOutlet = () => {
  return (
    <AuthContextProvider>
      <MsalProvider instance={msalInstance}>
        <Outlet />
      </MsalProvider>
    </AuthContextProvider>
  );
};

export const Layout = () => {
  return (
    <Schedule4DProvider>
      <HorizontalNavbar />
      <ModuleRouteGuard>
        <Outlet />
      </ModuleRouteGuard>

      {/* <Footer /> */}
    </Schedule4DProvider>
  );
};
